import {Form as AntForm} from "antd";

export const Form = AntForm;
export default Form;
